import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "text", "error", "classes", "tag"];
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { createUseStyles } from 'react-jss';
import withMemo from '../../../decorators/withMemo';
import { mergeStyles } from '../../../utils/StyleUtils';
import MarkdownText from '../../MarkdownText';
import styles from './styles';
var useStyles = createUseStyles(styles);
function FormHelpText(props) {
  var className = props.className,
    text = props.text,
    error = props.error,
    classesProp = props.classes,
    tag = props.tag,
    others = _objectWithoutProperties(props, _excluded);
  var classesComp = useStyles(props);
  var classes = useMemo(function () {
    return mergeStyles(classesComp, classesProp);
  }, [classesProp, classesComp]);
  if (!text || error) {
    return null;
  }
  return text && /*#__PURE__*/React.createElement(MarkdownText, _extends({
    text: text,
    tag: tag,
    inline: true
  }, others, {
    className: cx(classes.container, className)
  }));
}
FormHelpText.styles = styles;
FormHelpText.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  text: PropTypes.string,
  error: PropTypes.bool,
  tag: PropTypes.string
};
FormHelpText.defaultProps = {
  classes: {},
  className: null,
  text: '',
  error: false,
  tag: 'span'
};
export default withMemo()(FormHelpText);